import React, { Component } from "react";
import { connect } from "react-redux";
import { CONFIGURATION } from "utilities/configuration";
import { Button, Checkbox, FormControlLabel } from "@mui/material";

import { withLocalizer } from "utilities/withLocalizer";
import ItineraryInfo from "../common/itineraryInfo";
import commonUtilities from "utilities/common";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import ErrorAlert from "../common/errorAlert";

import "../../customize.scss";

export class CustomizeQuoteStepOne extends Component {
    constructor(props) {
        super(props);
    }

    handleItinerarySelectorChange = async (itineraryNumber) => {
        let { customQuote } = this.props;
        let isIncluded = false;
        await this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map(itinerary => {
                        if(itinerary.itineraryNumber === itineraryNumber) {
                            isIncluded = !itinerary.included;
                            return { ...itinerary, included: !itinerary.included };
                        }
                        else {
                            return itinerary;
                        }
                    })
                }))
            }))
        }));

        if(isIncluded &&this.props.events && this.props.events.onValidateStep1Data) {
            this.props.events.onValidateStep1Data();
        }
    };

    handleDateChange = async (date, itinerary) => {
        let { customQuote } = this.props;
        const itineraryNumber = itinerary.itineraryNumber;
        const validDate = date && date.toISOString();
        await this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map(itinerary => {
                        if(itinerary.itineraryNumber === itineraryNumber) {
                            let showValidDateWarningIcon = itinerary.showValidDateWarningIcon || false;
                            if(!commonUtilities.IsEqualDate(validDate, itinerary.validDate)) {
                                showValidDateWarningIcon = false;
                            }
                            return { ...itinerary, validDate: validDate, showValidDateWarningIcon: showValidDateWarningIcon };
                        }
                        else {
                            return itinerary;
                        }
                    })
                }))
            }))
        }));
    };

    handleAll = (hasSelected) => {
        let { customQuote } = this.props;
        this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: customQuote?.data?.quoteOptions?.map(quoteOption => ({
                ...quoteOption,
                products: quoteOption.products.map(product => ({
                    ...product,
                    itineraries: product.itineraries?.map((itinerary) => {
                        return { ...itinerary, included: !hasSelected };
                    })
                }))
            }))
        }));
    };

    handleViewMore = () =>{
        let { customQuote } = this.props;
        let quoteOptions = customQuote?.data?.quoteOptions || [];

        let showItinerariesSelected = 0;
        let i = 0;

        const updatedQuoteOptions = quoteOptions.map((quoteOption) => ({
            ...quoteOption,
            products: quoteOption.products.map((product) => ({
                ...product,
                itineraries: product.itineraries?.map((itinerary) => {
                    let hidden = itinerary.hidden;
                    if(hidden) {
                        i = i + 1;
                        hidden = (i > CONFIGURATION.CUSTOM_QUOTE_ITINERARY_PAGE_SIZE);
                    }
                    if(hidden === false) {
                        showItinerariesSelected = showItinerariesSelected + 1;
                    }
                    return { ...itinerary, hidden };
                })
            }))
        }));

        // Update the store with new data object
        this.props.dispatch(updateCustomQuote({
            ...customQuote.data,
            quoteOptions: updatedQuoteOptions,
            showItinerariesSelected
        }));
    };

    render() {
        const { data, customQuote, error, events } = this.props;
        const { currentStep } = data;
        
        if (currentStep !== 1) {
            return null;
        }

        let { showItinerariesSelected, totalItineraries } = customQuote?.data ?? {};
        let index = 0;

        let hasSelected = false;
        let { quoteOptions } = customQuote?.data || [];

        const languageCode = customQuote?.data?.languageCode || "en";

        quoteOptions?.map((quoteOption) => {
            quoteOption.products.map((product) => {
                product.itineraries?.map((quoteItinerary) => {
                    if(quoteItinerary.included) {
                        hasSelected = true;
                    }
                });
            });
        });

        return (
            <>
                {quoteOptions ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-1-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-1-intro") }
                            </div>
                        </div>
                        <div className="text-right-align margin-top-2x margin-bottom top-command">
                            <Button
                                className="link-button"
                                data-testid={"deselectAllBtn"}
                                onClick={() => this.handleAll(hasSelected)}
                            >
                                {hasSelected ? this.props.localize("qma-deselect-all") : this.props.localize("qma-select-all") }
                            </Button>
                        </div>
                        <div className="custom-quote-editor-container">
                            {quoteOptions?.map((option, optionIndex) => 
                                option?.products?.map((product, productIndex) => 
                                    product?.itineraries?.map((itinerary, itineraryIndex) => 
                                    {
                                        index = index + 1;
                                        let classNames = "custom-quote-editor-panel-wrapper splitter " + (itinerary?.hidden ? "hide" : "show");
                                        return (
                                            <div key={index} className={classNames}>
                                                <div className="custom-quote-editor-panel">
                                                    <div className="d-flex">
                                                        <div className="col-itinerary-selector">
                                                            <FormControlLabel control={<Checkbox checked={itinerary.included} onChange={() => this.handleItinerarySelectorChange(itinerary.itineraryNumber)} />} label={itinerary.itineraryNumber + "."} />
                                                        </div>
                                                        <div className="col-itinerary-info">
                                                            <ItineraryInfo option={option} itinerary={itinerary} product={product} includeExpiryDateSelector={true} languageCode={languageCode} handleDateChange={this.handleDateChange} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                )
                            )}
                        </div>
                        {showItinerariesSelected && totalItineraries && showItinerariesSelected !== totalItineraries ?
                            <div className="text-center">
                                <div className="margin-top-1x">
                                    { this.props.localize("qma-custom-quote-editor-itinerary-list-status").replace("{0}", showItinerariesSelected).replace("{1}", totalItineraries) }
                                </div>
                                <div className="margin-top-1x">
                                    <Button className="btn-blue-white btn-white-blue-sm" data-testid="info-btn" variant="contained" onClick={ ()=> this.handleViewMore() }>
                                        { this.props.localize("qma-view-more") }
                                    </Button>
                                </div>
                            </div>
                            :
                            null
                        }
                    </div>
                    : null}
                {error && error.trim().length > 0 ?
                    <ErrorAlert 
                        error={error} 
                        isShowAlert={(error && error.trim().length > 0)} 
                        closeAlert={() => this.props.events && this.props.events.onAlertClose && this.props.events.onAlertClose()} 
                    />
                    : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteStepOne));
